import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class CustomPageService {
   


    setCustomStyles(hostname,subdomain,customEcommerce,environment){
        if(hostname != environment.domain){
         const styleTag = document.createElement('style');
            styleTag.innerHTML = `
            .dropDownStyle {background : ${customEcommerce[subdomain].mainColor } !important}
            .auth-buttons-container {background : transparent !important }
            .auth-btn {color : ${customEcommerce[subdomain].menu.iconColors }!important;}
            .auth-buttons-container {background : transparent !important }
            .search-icon-btn {background-color : ${customEcommerce[subdomain].mainColor }!important}
            .menu-item {

                color : ${customEcommerce[subdomain].menu.myProfile.textColor};
                &:hover{
                    color: ${customEcommerce[subdomain].menu.myProfile.textColorHover} !important;
                } 
            }
            .color-blue-lang {

                color : ${customEcommerce[subdomain].menu.myProfile.textColor};
                &:hover{
                    color: ${customEcommerce[subdomain].menu.myProfile.textColorHover} !important;
                } 
            }



            body {font-family: ${customEcommerce[subdomain].fontFamily} !important;} 

            .btn-orange {
                background-color: ${customEcommerce[subdomain].btnColorImage} !important;
                color : ${customEcommerce[subdomain].btnTextColor} !important;
            }

            .separator{
                background-color: ${customEcommerce[subdomain].btnColor} !important;
            }

            .total-amount-div{
             background: ${customEcommerce[subdomain].mainColor} !important;
            }

            .step-container{
             .step{
             .step-content {
             }
              }
            }

            .step {
                .step-content {
                    background-color : ${customEcommerce[subdomain].desktopUnFilledStepColor} !important;
                    border-top: 1px solid ${customEcommerce[subdomain].desktopStepBorderColor} !important;
                    border-left: 1px solid ${customEcommerce[subdomain].desktopStepBorderColor} !important;
                    border-bottom: 1px solid ${customEcommerce[subdomain].desktopStepBorderColor} !important;
                }

                svg path {
                    fill: ${customEcommerce[subdomain].desktopUnFilledStepColor} !important;
                    stroke: ${customEcommerce[subdomain].desktopStepBorderColor} !important;
                
                }
            }

            .step-success {
               .step-content {
                    background-color: ${customEcommerce[subdomain].stepBackgropund} !important;
                }
                svg path {
                 fill: ${customEcommerce[subdomain].stepBackgropund} !important;
                 stroke: ${customEcommerce[subdomain].desktopStepBorderColor} !important;
                }
            }

            .step-next {
                svg path {
                    fill: #F1F3F7 !important;
                    stroke: ${customEcommerce[subdomain].desktopStepBorderColor} !important;
                }
            }
        
        
            .active-step {
                background-color : ${customEcommerce[subdomain].stepBackgropund} !important; 
            }

            .step { 
             color : ${customEcommerce[subdomain].stepTextColor} !important; 
            }

            .selected{
             background-color : ${customEcommerce[subdomain].stepBackgropund} !important; 
            }
             
            .orange-shadow {
                &:hover{
                    background: ${customEcommerce[subdomain].btnColorHover} !important;
                    color: ${customEcommerce[subdomain].btnHoverTextColor} !important;
                    border-color: ${customEcommerce[subdomain].btnHoverTextColor} !important;
                } 
                &:active {
                    background: ${customEcommerce[subdomain].btnColorActive} !important;
                    border-color: ${customEcommerce[subdomain].btnColorImage} !important;
                }
            }


        
            *:not(.cc-dismiss, .gray-button, .cc-link, .cc-message,.material-symbols-outlined, .payment-method-disabled-icon, .payment-method-disabled-text, .color-white,
                .btn-outline,.selected-payment-text, .plus-icon, .payment-method-text, .c-white, .seleceted-terms,
                .tooltip-inner, .btn-primary, .product-header, .font-custom-color, .btn-solid,
                .cart_qty_cls, .fa-user, .ti-shopping-cart, .product-type-cnt, .notification-message, .now-cnt,
                .noty-info, .noty-success, .step, .noty-warning, .noty-error, .group-items-border, .fc-h-event .fc-event-main ,
                .notification-message-date, .not-include, .product-pagination .pagination .page-item.active a, .angle-text-color, .calendar-product-title, .color-gray, .policy-error-label>b) {
                color: ${customEcommerce[subdomain].textColor};
            }`;

            document.head.appendChild(styleTag);
        }
    }

}
